import BillService from './BillService'

import {
  Container,
  Title,
  SubTitle,
  LabelRow
} from './styles'

export default function BillServiceList ({
  bill,
  billServices = [],
  professionals = [],
  freeItems = [],
  showFreeItemsValue = false,
  enableEditting = true,
  hasEditPermission = true,
  hasDeletePermission = true,
  onToggleFree: handleToggleFree = () => null,
  onEdit: handleEdit,
  onDelete: handleDelete
}) {
  return billServices.length > 0 && (
    <Container>
      <Title>Serviços adicionais</Title>
      <LabelRow enableEditting={enableEditting}>
        <SubTitle>Serviço</SubTitle>
        <SubTitle>Profissional</SubTitle>
        <SubTitle>Qtd</SubTitle>
        <SubTitle>Preço</SubTitle>
        <SubTitle>Comissão</SubTitle>
        {enableEditting && <SubTitle>Ações</SubTitle>}
      </LabelRow>
      {billServices.map ((service, index) => (
        <BillService
          key={index}
          bill={bill}
          data={service}
          professionals={professionals}
          freeItems={freeItems}
          showFreeItemsValue={showFreeItemsValue}
          enableEditting={enableEditting}
          hasEditPermission={hasEditPermission}
          hasDeletePermission={hasDeletePermission}
          onToggleFree={handleToggleFree}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      ))}
    </Container>
  )
}
